export const stringSchemaValidator = val => {
  if (typeof val !== 'string') {
    return 'Value must be a string';
  }
  return '';
};

export const intSchemaValidator = val => {
  if (!Number.isInteger(val)) {
    return 'Value must be an integer';
  }
  return '';
};

export const floatSchemaValidator = val => {
  if (typeof val !== 'number') {
    return 'Value must be a number';
  }
  if (!Number.isFinite(val)) {
    return 'Value must be a finite number';
  }
  return '';
};

export const mapSchemaValidator = (
  keySchemaValidator,
  valueSchemaValidator,
) => data => {
  const entries = Object.entries(data);
  for (let i = 0; i < entries.length; i += 1) {
    const [key, value] = entries[i];
    let errString = keySchemaValidator(key);
    if (errString !== '') {
      return errString;
    }
    errString = valueSchemaValidator(value);
    if (errString !== '') {
      return errString;
    }
  }
  return '';
};

export const regexSchemaValidator = regex => val => {
  if (!regex.test(val)) {
    return 'Value does not match regex';
  }
  return '';
};

export const enumSchemaValidator = (enumMap, enumName) => val => {
  if (!Object.values(enumMap).includes(val)) {
    return `Value is of invalid type for enum ${enumName}`;
  }
  return '';
};

export const schemaKeyValidator = (keySchema, key) => {
  return keySchema.has(key);
};

/* function validates fields in tracking key map by using validators specified against them
if field is recursive then we call function again with new trackkeymap
*/
export const validateAndRectifyTrackingData = trackingKeyValidatorMap => data => {
  const newData = {};
  Object.keys(trackingKeyValidatorMap)?.forEach(key => {
    if (trackingKeyValidatorMap[key]?.useDefaultAlways) {
      // for values were we don't want client controlled inputs, we take default values
      newData[key] = trackingKeyValidatorMap[key].default;
      return;
    }

    if (trackingKeyValidatorMap[key]?.recursive) {
      // recursively form keys from flat structure to create nested structure
      newData[key] = validateAndRectifyTrackingData(
        trackingKeyValidatorMap[key]?.trackKeys ?? {},
      )(data);
      return;
    }

    if (key in data) {
      const value = data[key];
      const validatorList = trackingKeyValidatorMap[key]?.validators ?? [];
      // check validators so that schema violations do not occur
      validatorList?.forEach(validator => {
        const errString = validator(value);
        if (errString !== '') {
          throw new Error(errString);
        }
      });
      newData[key] = value;
    } else {
      // add compulsory keys present in tracking schema
      newData[key] = trackingKeyValidatorMap[key].default;
    }
  });

  return newData;
};
